import { observer } from "mobx-react-lite"

import { Button } from "@/components/button"
import { Table, TableBody, TableCell, TableHead, TableHeaderMinimal, TableRow } from "@/components/table"
import { DisplayTokenRow } from "@/domains/common/components/display-token-row"
import { cn } from "@/domains/library"
import { MinimalPoolStore } from "@/domains/minimal-pool"
import { DisplayMinimalPool } from "@/domains/minimal-pool/components/display-minimal-pool"

export const StoreDesktopFeesView = observer(
  ({ pools, onClaimLpFees }: { pools: Array<MinimalPoolStore>; onClaimLpFees: (pool: MinimalPoolStore) => void }) => {
    return (
      <div className="overflow-hidden rounded-t-xl border border-p400-light ">
        <Table>
          <TableHead>
            <TableRow>
              <TableHeaderMinimal className="text-left" isSortDisabled={true}>
                Pool
              </TableHeaderMinimal>
              <TableHeaderMinimal className="text-right" isSortDisabled={true}>
                My Unstaked
              </TableHeaderMinimal>
              <TableHeaderMinimal className="text-right" isSortDisabled={true}>
                Earned
              </TableHeaderMinimal>
              <TableHeaderMinimal className="text-center" isSortDisabled={true}>
                Action
              </TableHeaderMinimal>
            </TableRow>
          </TableHead>

          <TableBody>
            {pools.map((pool, index) => {
              const isFirstItem = index === 0
              return (
                <TableRow className={cn(!isFirstItem && "border-t border-t-p400-light")} key={pool.address.toString()}>
                  <TableCell>
                    <DisplayMinimalPool pool={pool} label={pool.displayType} className="flex-row items-start" />
                  </TableCell>
                  <TableCell className="space-y-1 self-center text-xs">
                    <DisplayTokenRow token={pool.token0} amount={pool.onChainUserBalanceToken0} />
                    <DisplayTokenRow token={pool.token1} amount={pool.onChainUserBalanceToken1} />
                  </TableCell>
                  <TableCell className="flex flex-col justify-end space-y-2 text-xs">
                    <DisplayTokenRow token={pool.token0} amount={pool.onChainUserClaimableFees0} />
                    <DisplayTokenRow token={pool.token1} amount={pool.onChainUserClaimableFees1} />
                  </TableCell>
                  <TableCell className="content-center">
                    <Button
                      title="Claim fees"
                      onClick={() => {
                        void onClaimLpFees(pool)
                      }}
                      variant="percentage"
                      className="mx-auto"
                    >
                      Claim
                    </Button>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </div>
    )
  },
)
